/* eslint-disable max-len */
import { getDefaultExport, importAfterPreLoad, lazyLoad } from '../components/utils';

const SDKCampaignCreationPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "sdk-campaign-creation-page" */'../feature-bootstrap/sdk-campaign-creation').then(getDefaultExport), true);

const SDKCampaignOverviewPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "sdk-campaign-overview-page" */'../feature-bootstrap/sdk-campaign-overview').then(getDefaultExport), true);

const SDKAssetGroupSettingsPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "sdk-asset-group-settings-page" */'../feature-bootstrap/sdk-asset-group-settings').then(getDefaultExport), true);

const SDKTargetSettingsPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "sdk-target-settings-page" */'../feature-bootstrap/sdk-target-settings').then(getDefaultExport), true);

const SDKBudgetSettingsPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "sdk-budget-settings-page" */'../feature-bootstrap/sdk-budget-settings').then(getDefaultExport), true);

const SDKAppWrapper = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "sdk-app-wrapper-loader" */'./sdk-app-wrapper-loader').then(getDefaultExport), true);

export const LazySDKAppWrapper = lazyLoad(SDKAppWrapper);

export const routes = {
  SDKCampaignCreationPage,
  SDKCampaignOverviewPage,
  SDKAssetGroupSettingsPage,
  SDKTargetSettingsPage,
  SDKBudgetSettingsPage,
};

